/**
 * Stops the browser from navigating to a file dropped anywhere but a drop zone — which would
 * discard whatever the page was in the middle of.
 *
 * react-dnd's HTML5Backend used to install this for the whole document; nothing in @dnd-kit
 * replaces it, since @dnd-kit does not deal with native file drags at all.
 *
 * A DropZone calls preventDefault as the event bubbles past it, so anything still unprevented by
 * the time it reaches the window landed on no zone and is refused.
 */
export const blockStrayFileDrops = (): (() => void) => {
  const refuse = (event: Event) => {
    if (event.defaultPrevented) return;

    event.preventDefault();
    const { dataTransfer } = event as DragEvent;
    if (event.type === 'dragover' && dataTransfer != null) dataTransfer.dropEffect = 'none';
  };

  window.addEventListener('dragover', refuse);
  window.addEventListener('drop', refuse);

  return () => {
    window.removeEventListener('dragover', refuse);
    window.removeEventListener('drop', refuse);
  };
};
